import { MouseEvent, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { Button } from "./button";

const CollapsibleCard = ({ title, children, className = "", open = false, more = true }: {
  title: string,
  children: any,
  className?: string,
  open?: boolean
  more?: boolean
}) => {
  const [isOpen, setIsOpen] = useState(open);

  return (
    <>
      <div
        className={`flex justify-between items-top pt-1 pl-1 pr-1 text-black ${className} ${more ? "cursor-pointer hover:text-white" : ""}`}
        onClick={() => more && setIsOpen(!isOpen)}
      >
        {!more ? (
          <h2 className={`text-lg font-semibold w-full flex justify-between items-center`}>
            <span className={`text-xl text-left`}>{title}</span>
          </h2>
        ) : (

          <Button className={`w-full bg-transparent text-black ${more ? "hover:text-white" : ""}`} onClick={(event: MouseEvent<HTMLButtonElement>) => {
            event.stopPropagation();
            more && setIsOpen(!isOpen)
          }}>
            <h2 className={`text-lg font-semibold w-full flex justify-between items-center text-black ${more ? "hover:text-white" : ""}`}>
              <span className={`text-xl text-left`}>{title}</span>
              {more && (
                <span className="text-xl text-right">{isOpen ?
                  <FontAwesomeIcon icon={faCaretUp}/> :
                  <FontAwesomeIcon icon={faCaretDown}/>}</span>
              )}
            </h2>
          </Button>
        )}
      </div>

      {/* Collapsible content */}
      <div className={`relative overflow-hidden transition transition-transform duration-150 ease-in-out z-20 ${isOpen ? 'max-h-full' : 'max-h-40'}`}>
        <div className="text-gray-700 text-sm">
          {children}
        </div>

        {!isOpen && (
          <div
            className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-white to-white/0 pointer-events-none">
          </div>
        )}
      </div>
    </>
  );
}

export default CollapsibleCard;
